import React, { useMemo, useCallback } from 'react';
import classnames from 'classnames';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import Icon from 'monday-ui-react-core/dist/Icon';
import Button from 'monday-ui-react-core/dist/Button';
import CloseIcon from 'monday-ui-react-core/dist/icons/Close';

import { NO_OP } from '../../constants';

import './tipseen-tooltip-component.scss';

export default function TipseenTooltipComponent({
  children,
  title,
  description,
  buttonTitle,
  tipseen,
  onClick = NO_OP,
  onClose = NO_OP,
  syncTipseen = NO_OP,
  hideCloseButton,
  className,
  open,
  ...restProps
}) {
  const onTooltipClose = useCallback(() => {
    tipseen && syncTipseen(tipseen);

    onClose();
  }, [tipseen, syncTipseen, onClose]);

  const onButtonClick = useCallback(
    (e) => {
      e.preventDefault();

      tipseen && syncTipseen(tipseen);
      onClick();
    },
    [tipseen, syncTipseen, onClick]
  );

  const tooltipContent = useMemo(() => {
    return (
      <div className="tipseen-tooltip-content-wrapper">
        {!hideCloseButton && (
          <div className="tipseen-tooltip-close-button">
            <Icon icon={CloseIcon} onClick={onTooltipClose} />
          </div>
        )}
        <div className="content">
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
        {/* To use  ON_PRIMARY_COLOR must specify backgroundColor as inline-style*/}
        {buttonTitle && (
          <div className="button-wrapper" style={{ backgroundColor: 'var(--primary-color)' }}>
            <Button kind={Button.kinds.PRIMARY} color={Button.colors.ON_PRIMARY_COLOR} onClick={onButtonClick}>
              {buttonTitle}
            </Button>
          </div>
        )}
      </div>
    );
  }, [title, description, buttonTitle, onButtonClick, hideCloseButton, onTooltipClose]);

  if (!open) {
    return children;
  }

  return (
    <div className="tipseen-tooltip-component">
      <Tooltip
        content={tooltipContent}
        wrapperClassName={classnames('tipseen-tooltip-wrapper', className)}
        open={open}
        {...restProps}
      >
        {children}
      </Tooltip>
    </div>
  );
}
